module.exports = __webpack_public_path__ + "img/reportB.64592fb1.png";